import { IPolicyTermQuery } from "../../models/policy-term/query";
import { IPolicyTerm } from "../../models/policy-term/response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer, { QueryAction } from "../base/base-reducer";
import { PolicyTermLoading, IInternalState } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: PolicyTermLoading | PolicyTermLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IPolicyTerm } }
  | QueryAction<IPolicyTermQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
